import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ValidationErrorInterface } from '@zaoblako/shared/common/interfaces/validation-error.interface';
import type { CurrencyFindInterface } from '@zaoblako/shared/modules/catalog/dtos/currency/currency-find.dto';
import type { NdsFindInterface } from '@zaoblako/shared/modules/finance/dtos/nds-find.dto';
import type { TaskOrderFormInterface } from '@zaoblako/shared/modules/task/dtos/order/task-order-form.dto';
import { CrmTableColumn } from '@zaoblako/web/core/models/crm-table-column.interface';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';
import { DatepickerComponent } from '@zaoblako/web/shared/dumbs/datepicker/datepicker.component';
import { InputTextComponent } from '@zaoblako/web/shared/dumbs/input-text/input-text.component';
import { TableComponent } from '@zaoblako/web/shared/dumbs/table/table.component';
import { TemplateSubjectInputComponent } from '@zaoblako/web/shared/dumbs/template-subject-input/template-subject-input.component';
import { JoinPipe } from '@zaoblako/web/shared/pipes/join.pipe';
import { CardModule } from 'primeng/card';
import { InputNumberModule } from 'primeng/inputnumber';

@Component({
  standalone: true,
  selector: 'crm-payment-order-task',
  templateUrl: './payment-order-task.component.html',
  imports: [
    CommonModule,
    CardModule,
    InputNumberModule,
    FormsModule,
    DatepickerComponent,
    TemplateSubjectInputComponent,
    InputTextComponent,
    ButtonComponent,
    TableComponent,
    JoinPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentOrderTaskComponent implements OnInit {
  @Input() public orders: TaskOrderFormInterface[];
  @Output() public ordersChange = new EventEmitter<TaskOrderFormInterface[]>();

  @Input() public nds: NdsFindInterface[] = [];
  @Input() public currency: CurrencyFindInterface = null;
  @Input() public rate: number = 1;

  @Input() public disabled = false;
  @Input() public templatedSubject = false;
  @Input() public withCard = true;

  @Input() public minDate: Date;

  @Input() public styleClass: string;
  @Input() public errors: Array<ValidationErrorInterface<TaskOrderFormInterface>>;

  public columns: CrmTableColumn[] = [
    { label: '№' },
    { label: 'Сумма' },
    { label: 'Дата оплаты' },
    { label: 'Назначение' },
    {}
  ];

  public ngOnInit(): void {
    if (!this.withCard) {
      this.addOrder();
    }
  }

  public toOrder(order: any): TaskOrderFormInterface {
    return order as TaskOrderFormInterface;
  }

  public addOrder() {
    if (!this.orders) {
      this.orders = [];
    }
    const item = <TaskOrderFormInterface>{};
    item.subject = '';
    this.orders.push(item);
    this.orders = [...this.orders];
    this.ordersChange.emit(this.orders);
  }

  public deleteOrder(order: TaskOrderFormInterface) {
    this.orders = this.orders.filter((_order) => _order !== order);
    this.ordersChange.emit(this.orders);
  }

  public changeAmountInOrder(order: TaskOrderFormInterface, amount: string | number) {
    order.amount = Number(amount);
  }
}
